export default [
    require('@/assets/images/bg-tab-2.png'),
    require('@/assets/images/body.jpg'),
    require('@/assets/images/layer-char-1.png'),
    // require('@/assets/images/m/layer-main.png'),
    // require('@/assets/images/m/bg-modal-rule.png'),
    // require('@/assets/images/m/modal-bind.png'),
    // require('@/assets/images/m/modal-comfirm.png'),
    // require('@/assets/images/m/modal-task.png'),
    // require('@/assets/images/m/modal-ticket.png'),
];


// WEBPACK FOOTER //
// ./src/assets/js/imgPreloaderList.js